import { useBreakpointIndex } from '@theme-ui/match-media';
import React from 'react';
import { AccordionItemHeading } from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { MOBILE_BREAKPOINT_INDEX } from '../../consts/style-consts';
import { StAccordionItem } from '../../shared-styled/blocks/AccordionBlocks';
import { RegularAnchor } from '../../shared-styled/typography/Anchors';
import {
  Container,
  Title,
  Paragraph,
  Separator,
  TableAccordion,
  TableAccordionItemButton,
  TableAccordionItemPanel,
  TableAccordionSeparator,
  // AnchorLink,
} from './TableOfContents.styled';

const TableOfContents = ({ className, data, dark, small }) => {
  const index = useBreakpointIndex();

  return index <= MOBILE_BREAKPOINT_INDEX ? (
    <TableAccordion allowZeroExpanded dark={dark} className={className}>
      <StAccordionItem>
        <AccordionItemHeading>
          <TableAccordionItemButton>Table of contents</TableAccordionItemButton>
        </AccordionItemHeading>
        <TableAccordionItemPanel>
          <TableAccordionSeparator />
          {data.map(({ id, title, level, key }, i) => (
            <RegularAnchor key={key} href={`#${id}`}>
              <Paragraph
                small={small}
                hasChildren={!!data[i + 1] && data[i + 1]?.level > level}
              >
                {title}
              </Paragraph>
            </RegularAnchor>
          ))}
        </TableAccordionItemPanel>
      </StAccordionItem>
    </TableAccordion>
  ) : (
    <Container className={className} dark={dark}>
      <Title>Table of Contents</Title>
      <Separator />
      {data.map(({ id, title, level, key }, i) => (
        <RegularAnchor key={key} href={`#${id}`}>
          <Paragraph
            small={small}
            level={level}
            hasChildren={!!data[i + 1] && data[i + 1]?.level > level}
          >
            {title}
          </Paragraph>
        </RegularAnchor>
      ))}
    </Container>
  );
};

TableOfContents.propTypes = {};

TableOfContents.defaultProps = {
  data: [],
};

export default TableOfContents;
